import React from 'react';
import { FaLaptop, FaUsers, FaFolderOpen } from 'react-icons/fa';
import {
  OnlineAccessSection,
  OnlineAccessContent,
  TextLink,
  AccessList,
  AccessItem,
  AccessIcon,
} from './Access.styles';

const Access = () => {
  return (
    <OnlineAccessSection>
      <OnlineAccessContent>
        <p className="eyebrowHeader">Company Account Access</p>

        <h2>Keep Important Safety Information Within Reach</h2>

        <p>
          Safety manuals do more good when employees can actually find them.
          Your completed manual can be made available through your Yoda Safety
          Services company account, giving your team a central place to access
          workplace safety information online.
        </p>

        <p>
          This can help reduce reliance on scattered files or paper copies and
          keep important documentation connected with the other safety tools
          available through your company account.
        </p>

        <TextLink to="/company-training">
          Explore Company Accounts
          <span aria-hidden="true">→</span>
        </TextLink>
      </OnlineAccessContent>

      <AccessList>
        <AccessItem>
          <AccessIcon>
            <FaLaptop />
          </AccessIcon>

          <div>
            <strong>Digital Access</strong>
            <span>
              Make the manual available online through the company account.
            </span>
          </div>
        </AccessItem>

        <AccessItem>
          <AccessIcon>
            <FaUsers />
          </AccessIcon>

          <div>
            <strong>Employee Availability</strong>
            <span>
              Give your team a clearer place to find workplace information.
            </span>
          </div>
        </AccessItem>

        <AccessItem>
          <AccessIcon>
            <FaFolderOpen />
          </AccessIcon>

          <div>
            <strong>Centralized Documentation</strong>
            <span>Keep important safety resources connected in one place.</span>
          </div>
        </AccessItem>
      </AccessList>
    </OnlineAccessSection>
  );
};

export default Access;
